import { useEffect } from "react";
import {
    safeLocalStorage,
    safeSessionStorage,
} from "@smile2impress/attraction-utils";

import { LOCAL_STORAGE_KEYS, SESSION_STORAGE_KEYS } from "constants/enum";
import { generateUuid } from "utils/generateUuid";

export const useGenerateVidAndSessionId = () => {
    useEffect(() => {
        let vid = safeLocalStorage.getItem(LOCAL_STORAGE_KEYS.VID);
        let sessionId = safeSessionStorage.getItem(
            SESSION_STORAGE_KEYS.SESSION_ID
        );

        if (!vid) {
            vid = generateUuid();
            safeLocalStorage.setItem(LOCAL_STORAGE_KEYS.VID, vid);
        }

        if (!sessionId) {
            sessionId = generateUuid();
            safeSessionStorage.setItem(
                SESSION_STORAGE_KEYS.SESSION_ID,
                sessionId
            );
        }
    }, []);
};
